import React, { FunctionComponent } from "react";
import { styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { SidebarItem, SidebarItemComponent } from "./sidebar-item";

interface SidebarItems {
    items: SidebarItem[];
    sidebarItemHeight: string;
    onItemNameChange: (id: string, name: string) => void;
    blockInteractivity?: boolean;
    onInvalidNameInputted: () => void;
}

export const SelectedBar = styled.div<{ selected: boolean; position: "absolute" | "relative" }>`
    position: ${({ position }) => position};
    z-index: 100;
    top: 0;
    left: 0;
    height: 100%;
    min-width: 5px;
    background-color: ${({ theme, selected }: { theme: Theme; selected: boolean }) => (selected ? theme.primaryColors.focusAccent : "none")};
    border-radius: 2px;
`;

/**
 * A component which creates SidebarItems from an array
 * @param {SidebarItem[]} items - an array of items to create
 * @param {boolean} allowEditName - if the name is allowed to be changed
 */
export const SidebarItemsComponent: FunctionComponent<SidebarItems> = ({ items, sidebarItemHeight, onItemNameChange, onInvalidNameInputted, blockInteractivity = false }) => (
    <SidebarItemsContainer>
        {items.map((item) => (
            <ItemContainer key={item.id} isItemVisible={item.visible}>
                <SelectedBar position="relative" selected={item.selected} />
                <SidebarItemComponent
                    id={item.id}
                    name={item.name}
                    selected={item.selected}
                    singleSelection={item.singleSelection}
                    pending={item.pending}
                    itemOptions={item.itemOptions}
                    editName={item.editName}
                    changeEditName={item.changeEditName}
                    nameChange={item.nameChange}
                    onClick={item.onClick}
                    onItemNameChange={onItemNameChange}
                    allowEditName={item.allowEditName}
                    itemHeight={sidebarItemHeight}
                    blockInteractivity={blockInteractivity}
                    dataCy={item.dataCy}
                    onInvalidNameInputted={onInvalidNameInputted}
                />
            </ItemContainer>
        ))}
    </SidebarItemsContainer>
);

const ItemContainer = styled.div<{ isItemVisible: boolean }>`
    display: flex;
    color: ${({ isItemVisible = true, theme }: { isItemVisible: boolean; theme: Theme }) => `${isItemVisible ? theme.typographyColors.core : theme.shades.three}`};
`;

const SidebarItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    width: 95%;
    position: relative;
    overflow-y: auto;
`;
